import { useRef } from 'react';

export type UseFrozenWhileResult<T> = {
  value: T;
};

/**
 * Holds the last value seen before `frozen` went true, and keeps returning it until it goes false.
 *
 * For outliving the data that produced a view — an exit animation whose source has already been
 * torn away, say — so the view can finish on screen instead of blinking out from under itself.
 */
export const useFrozenWhile = <T>(value: T, frozen: boolean): UseFrozenWhileResult<T> => {
  const lastLiveValue = useRef(value);

  if (!frozen) {
    lastLiveValue.current = value;
  }

  return { value: frozen ? lastLiveValue.current : value };
};
